// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.member-list-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.member-list-container .add-modal {
  animation: fadeIn 0.5s;
}
.member-list-container .header {
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.member-list-container .header.button {
  align-items: center;
  justify-content: space-between;
}
.member-list-container .header.button > button {
  background: #F4F5F6;
  color: var(--secondary-color-1);
  align-items: center;
  display: flex;
  justify-content: center;
}
.member-list-container .header.button > button:hover {
  opacity: 0.75;
}
.member-list-container .header.button > button .notify {
  position: relative;
}
.member-list-container .header.button > button .notify::after {
  content: attr(data-count);
  position: absolute;
  height: 15px;
  padding-top: 3px;
  width: 15px;
  right: -7px;
  top: -7px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 10px;
  color: white;
  background-color: rgb(235, 74, 74);
}
.member-list-container .header > p {
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  color: var(--secondary-color-1);
  font-size: 20px;
}
.member-list-container .info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.member-list-container .info > p {
  font-family: "Proxima Nova", sans-serif;
  font-size: 16px;
  line-height: 24px;
  width: 800px;
  text-align: center;
  color: var(--secondary-color-1);
}
.member-list-container .info > p > span {
  font-weight: 700;
  text-decoration: underline;
}
.member-list-container .info > p > span.open-house {
  color: #c86ee5;
}
.member-list-container .info > p > span.blackout {
  color: var(--secondary-color-3);
}
.member-list-container .listing-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 300px;
}
.member-list-container .listing-section .members-count {
  align-self: flex-start;
  font-weight: 600;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.member-list-container .listing-section .members-count > span {
  color: #6C767C;
}
.member-list-container .listing-section .member-info {
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.member-list-container .listing-section .member-info > div {
  display: flex;
}
.member-list-container .listing-section .member-info > div img {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 10px;
}
.member-list-container .listing-section .member-info > div > div > p {
  font-weight: 600;
  font-size: 18px;
  margin: 0;
  color: var(--secondary-color-1);
}
.member-list-container .listing-section .member-info > div > div > span {
  font-weight: 400;
  font-size: 14px;
  color: #6C767C;
}
.member-list-container .listing-section .member-info .invite-status {
  font-weight: 600;
  font-size: 16px;
  color: #6C767C;
}
.member-list-container .empty {
  font-weight: 700;
  font-size: 216x;
  color: var(--secondary-color-2);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/TeamDetails/modules/MemberList/memberList.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAGI;EACI,sBAAA;AADR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AADR;AAEQ;EACI,mBAAA;EACA,8BAAA;AAAZ;AACY;EACI,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAChB;AAAgB;EACI,aAAA;AAEpB;AAAgB;EACI,kBAAA;AAEpB;AADoB;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kCAAA;AAGxB;AAEQ;EACI,SAAA;EACA,uCAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAAZ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAEQ;EACI,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAAZ;AACY;EACI,gBAAA;EACA,0BAAA;AAChB;AAAgB;EACI,cAAA;AAEpB;AAAgB;EACI,+BAAA;AAEpB;AAGI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAEQ;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAAZ;AACY;EACI,cAAA;AAChB;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAAZ;AACY;EACI,aAAA;AAChB;AAAgB;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAEpB;AACoB;EACI,gBAAA;EACA,eAAA;EACA,SAAA;EACA,+BAAA;AACxB;AACoB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AACxB;AAGY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AADhB;AAKI;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAHR;AAKI;EACI;IAAK,UAAA;EAFX;EAGM;IAAO,UAAA;EAAb;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n\r\n.member-list-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    .add-modal {\r\n        animation: fadeIn .5s;\r\n    }\r\n    .header {\r\n        display: flex;\r\n        align-items: flex-start;\r\n        width: 100%;\r\n        &.button {\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            > button {\r\n                background: #F4F5F6;\r\n                color: var(--secondary-color-1);\r\n                align-items: center;\r\n                display: flex;\r\n                justify-content: center;\r\n                &:hover {\r\n                    opacity: .75;\r\n                }\r\n                .notify {\r\n                    position: relative;\r\n                    &::after {\r\n                        content: attr(data-count);\r\n                        position: absolute;\r\n                        height: 15px;\r\n                        padding-top: 3px;\r\n                        width: 15px;\r\n                        right: -7px;\r\n                        top: -7px;\r\n                        border-radius: 100px;\r\n                        font-weight: 700;\r\n                        font-size: 10px;\r\n                        color: white;\r\n                        background-color: rgb(235, 74, 74);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        > p {\r\n            margin: 0;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            font-size: 20px;\r\n        }\r\n    }\r\n    .info {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        > p {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n            width: 800px;\r\n            text-align: center;\r\n            color: var(--secondary-color-1);\r\n            > span {\r\n                font-weight: 700;\r\n                text-decoration: underline;\r\n                &.open-house {\r\n                    color: #c86ee5;\r\n                }\r\n                &.blackout {\r\n                    color: var(--secondary-color-3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .listing-section {\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        padding: 0 300px;\r\n        .members-count {\r\n            align-self: flex-start;\r\n            font-weight: 600;\r\n            font-size: 16px;\r\n            color: var(--secondary-color-1);\r\n            > span {\r\n                color: #6C767C;\r\n            }\r\n        }\r\n        .member-info {\r\n            display: flex;\r\n            margin-bottom: 20px;\r\n            width: 100%;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            > div {\r\n                display: flex;\r\n                img {\r\n                    height: 45px;\r\n                    width: 45px;\r\n                    object-fit: cover;\r\n                    border-radius: 10px;\r\n                }\r\n                > div {\r\n                    > p {\r\n                        font-weight: 600;\r\n                        font-size: 18px;\r\n                        margin: 0;\r\n                        color: var(--secondary-color-1);\r\n                    }\r\n                    > span {\r\n                        font-weight: 400;\r\n                        font-size: 14px;\r\n                        color: #6C767C;\r\n                    }\r\n                }\r\n            }\r\n            .invite-status {\r\n                font-weight: 600;\r\n                font-size: 16px;\r\n                color: #6C767C;\r\n            }\r\n        }\r\n    }\r\n    .empty {\r\n        font-weight: 700;\r\n        font-size: 216x;\r\n        color: var(--secondary-color-2);\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet) { \r\n    .image-view-container {\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
